import FormModal from "../../commons/form-modal";
import Select from "../../commons/select";
import Input from "../../commons/input";
import { ACTION_TYPE } from "../../../constants/constant";

export const PayrollNotesForm = ({
    show,
    onHide,
    title,
    actionType,
    formValue,
    departmentOptions = [],
    divisionOptions = [],
    isDivisionLoading = false,
    onChangeDepartment,
    onChangeDivision,
    onChangeNotes,
    onSearchDepartment,
    onSearchDivision,
    isFormValid,
    onSubmitForm,
    isLoading,
}) => {
    return (
        <FormModal
            title={title || `${actionType === ACTION_TYPE.CREATE ? 'Create' : 'Edit'} Payroll Notes`}
            onSubmitForm={onSubmitForm}
            show={show}
            onHide={onHide}
            isDisabled={!isFormValid?.()}
            isLoading={isLoading}
        >
            <div className="flex flex-col px-6 py-8 gap-[20px]">
                <div className="flex flex-row items-center">
                    <div className="w-1/3 text-neutral-70 required">Department</div>
                    <Select
                        name="department"
                        className="flex-1"
                        placeholder="Pilih Department"
                        options={departmentOptions}
                        value={formValue?.department}
                        onChange={onChangeDepartment}
                        onSearch={onSearchDepartment}
                        optionsClassName="max-h-[250px]"
                    />
                </div>
                <div className="flex flex-row items-center">
                    <div className="w-1/3 text-neutral-70">Division</div>
                    <Select
                        name="division"
                        className="flex-1"
                        placeholder={
                            !formValue?.department
                                ? "Pilih Department terlebih dahulu"
                                : isDivisionLoading
                                ? "Loading division..."
                                : "Pilih Division"
                        }
                        options={divisionOptions}
                        value={formValue?.division}
                        onChange={onChangeDivision}
                        onSearch={onSearchDivision}
                        disabled={!formValue?.department || isDivisionLoading}
                        optionsClassName="max-h-[250px]"
                    />
                </div>
                <div className="flex flex-row items-start">
                    <div className="w-1/3 text-neutral-70 required pt-2">Notes</div>
                    <Input
                        type="text-area"
                        name="note"
                        className="flex-1"
                        classNameInput="overflow-y-auto"
                        placeholder="Inputkan catatan payroll"
                        value={formValue?.note}
                        onChange={onChangeNotes}
                        row={4}
                        showCount
                        maxLength={500}
                    />
                </div>
            </div>
        </FormModal>
    );
};
